import 'react-datepicker/dist/react-datepicker.css';
import '../../../styles/custom_css.sos-prev.css';

import { AddIcon, ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Fade,
  Flex,
  HStack,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import exportFromJSON from 'export-from-json';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { HiPlusCircle } from 'react-icons/hi';
import { useParams, useSearchParams } from 'react-router-dom';
import { Column } from 'react-table';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';

import { InteractiveTable } from '../../../components/data/InteractiveTable';
import { InteractiveTableModal } from '../../../components/data/InteractiveTableModal';
import { ValueCard } from '../../../components/data/ValueCard';
import { api } from '../../../services/api';
import * as SosPrevService from '../../../services/previdencia-individual/sos_prev';
import { cpf } from '../../../utils/masks';

type Found = {
  Nome_fundo: string;
  valor: string;
};

type Table = {
  CODIGO_EV: string;
  NOME: string;
  CPF: string;
  PROPOSTA: string;
  DATA_SOLICITACAO: string;
  DATA_PAGAMENTO: string;
  VALOR_EMPRESTIMO: string;
  TIPO_SITUACAO: string;
  // fundos: Found[];
};

type FundosDetails = {
  EV: string;
  ID_FUNDO: string;
  NOME_FUNDO: string;
  SALDO_FUNDO: string;
  VALOR_REAIS: string;
  CONTA_NEGOCIO_ID: string;
};

type FundosDetailsClientes = {
  DESCRICAO: string;
  CPF: string;
  PROPOSTA: string;
  COD_PRODUTO: string;
  DES_PRODUTO: string;
};

type TableData = {
  row: {
    original: {
      DATA_SOLICITACAO: string;
      DATA_PAGAMENTO: string;
      VALOR_EMPRESTIMO: number;
    };
  };
};

type HandleDetails = {
  row: {
    original: {
      CPF: string;
      NUM_PROPOSTA: string;
    };
  };
};

type SosPrevPageProps = {
  withPagination?: boolean;
};

export const SosPrev = ({
  withPagination = false
}: SosPrevPageProps): JSX.Element => {
  const toast = useToast();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlert,
    onClose: onCloseAlert
  } = useDisclosure();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3
  } = useDisclosure();

  const {
    isOpen: isOpen4,
    onOpen: onOpen4,
    onClose: onClose4
  } = useDisclosure();

  //Pagination
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get('page') || 1;
  console.log({ page });
  const [dataListFilterFields, setDataListFilterFields] = useState({
    cpf: '',
    nome: '',
    status: '',
    data_solicitacao: undefined,
    data_efetivacao: undefined
  });

  //Query lista paginação
  const {
    isLoading: isLoadingList,
    isFetching: isFetchingList,
    data: listData,
    refetch: refetchDataList
  } = useQuery<Table[]>(
    ['sos-prev-list', page, dataListFilterFields],
    () => SosPrevService.getData(Number(page), dataListFilterFields),
    {
      keepPreviousData: true,
      staleTime: 1000 * 60 * 5,
      retry: 3,
      retryDelay: 3000,
      refetchOnWindowFocus: false,
      onError: () => {
        toast({
          status: 'error',
          title: 'Ops! Ocorreu um erro na consulta',
          description: 'Tente novamente mais tarde!',
          isClosable: true
        });
      }
    }
  );

  //Count
  const { isLoading: isLoadingCount, isError: isErrorCount } = useQuery<{
    total_rows: number;
  }>(['sos-prev-count'], SosPrevService.getTotalCountRegisters, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retryDelay: 3000,
    onSuccess: (data) => setItemsCount(data.total_rows)
  });

  //Sum
  const [summarizedData, setSummarizatedData] = useState<{
    valorSaldo: number;
    quantidadeSolicitacoes: number;
  }>({
    valorSaldo: 0,
    quantidadeSolicitacoes: 0
  });

  const { isLoading: isLoadingSum } = useQuery(
    ['sos-prev-sum'],
    SosPrevService.getTotalSum,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retryDelay: 3000,
      onSuccess: (data) => {
        console.log({ data });
        setSummarizatedData({
          quantidadeSolicitacoes: data.quantidade_solicitacoes,
          valorSaldo: data.valor_saldo
        });
      }
    }
  );

  const [loadingFundos, setLoadingFundos] = useState(false);
  const [loadingFundosClientes, setLoadingFundosClientes] = useState(false);
  const [dataSolicitacao, setDataSolicitacao] = useState<any>();
  const [dataEfetivacao, setDataEfetivacao] = useState<any>();

  /* const [data, setData] = useState<Data>({
    summarized: {
      saldo_total: '0'
      // ev: '0',
      // fundos: [
      //   {
      //     nome_fundo: '',
      //     saldo: '',
      //     participantes: [
      //       {
      //         nome: '',
      //         cpf: '',
      //         proposta: '',
      //         saldo: ''
      //       }
      //     ]
      //   }
      // ]
    },
    table: [
      {
        NOME: '',
        CPF: '',
        NUM_PROPOSTA: '',
        COD_PRODUTO: '',
        DES_PRODUTO: '',
        DATA_NASCIMENTO: '',
        DATA_APOSENTADORIA: '',
        VLR_CONTRIB: '',
        TIPO_COBRANCA: '',
        STATUS: '',
        CODIGO_EV: '',
        CORRETOR: ''
        // fundos: [
        //   {
        //     Nome_fundo: '',
        //     valor: ''
        //   }
        // ]
      }
    ]
  }); */

  const [table, setTable] = useState<Table[]>([
    {
      CODIGO_EV: '',
      NOME: '',
      CPF: '',
      PROPOSTA: '',
      DATA_SOLICITACAO: '',
      DATA_PAGAMENTO: '',
      VALOR_EMPRESTIMO: '',
      TIPO_SITUACAO: ''
    }
  ]);

  // Dados para teste de layout
  const [tableFundosClientes, setTableFundosClientes] = useState<
    FundosDetailsClientes[]
  >([
    {
      DESCRICAO: '1',
      CPF: '1',
      PROPOSTA: 'teste teste',
      COD_PRODUTO: '123123123',
      DES_PRODUTO: 'teste 1'
    }
  ]);

  const [tableFundosClientesHeader, setTableFundosClientesHeader] =
    useState<FundosDetails>({
      EV: '',
      ID_FUNDO: '',
      NOME_FUNDO: '',
      SALDO_FUNDO: '',
      VALOR_REAIS: '',
      CONTA_NEGOCIO_ID: ''
    });

  const [itemsCount, setItemsCount] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(5);

  // const [nameFilter, setNameFilter] = useState('');
  //const [cpfFilter, setCpfFilter] = useState('');
  // const [productFilter, setProductFilter] = useState('');
  // const [statusFilter, setStatusFilter] = useState('');
  const nameInputRef = useRef() as MutableRefObject<HTMLInputElement>;
  const cpfInputRef = useRef() as MutableRefObject<any>;
  const dataSolicitacaoInputRef =
    useRef() as MutableRefObject<HTMLInputElement>;
  const dataEfetivacaoInputRef = useRef() as MutableRefObject<HTMLInputElement>;
  const statusSelectRef = useRef() as MutableRefObject<HTMLSelectElement>;

  const columns: Column<object>[] = [
    {
      Header: 'Nome do participante',
      accessor: 'NOME'
    },
    {
      Header: 'CPF do participante',
      accessor: 'CPF'
    },
    {
      Header: 'Número da proposta',
      accessor: 'PROPOSTA'
    },
    {
      Header: 'Data da Solicitação',
      accessor: 'DATA_SOLICITACAO',
      Cell: ({ row }: TableData) => {
        if (row.original.DATA_SOLICITACAO) {
          const dataFormatada = new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'UTC'
          }).format(new Date(row.original.DATA_SOLICITACAO));
          return <Text>{dataFormatada}</Text>;
        }

        return '-';
      }
    },
    {
      Header: 'Data da efetivação',
      accessor: 'DATA_PAGAMENTO',
      Cell: ({ row }: TableData) => {
        if (row.original.DATA_PAGAMENTO) {
          const dataFormatada = new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'UTC'
          }).format(new Date(row.original.DATA_PAGAMENTO));
          return <Text>{dataFormatada}</Text>;
        }

        return <Text> - </Text>;
      }
    },
    {
      Header: 'Valor',
      accessor: 'VALOR_EMPRESTIMO',
      Cell: ({ row }: TableData) => {
        const valorFormatado = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(Number(row.original.VALOR_EMPRESTIMO));
        return (
          <Text>
            {valorFormatado}
            {/* {new Intl.DateTimeFormat('pt-BR').format(
              new Date(row.original.DATA_SOLICITACAO)
            )} */}
          </Text>
        );
      }
    },
    {
      Header: 'Status',
      accessor: 'TIPO_SITUACAO'
    }
  ];

  const handleFilter = () => {
    const nameFilter = nameInputRef.current.value;
    const cpfFilter = cpfInputRef.current.inputElement.value.replace(
      /[^\d]/g,
      ''
    );

    const statusFilter = statusSelectRef.current.value;
    const dataSolicitacaoFilter = dataSolicitacao?.getTime();
    const dataEfetivacaoFilter = dataEfetivacao?.getTime();

    console.log({
      nameFilter,
      cpfFilter,
      statusFilter,
      dataSolicitacaoFilter,
      dataEfetivacaoFilter
    });

    if (cpfFilter.length > 0 && cpfFilter.length < 11) {
      toast({
        position: 'top',
        description: 'CPF incompleto, favor verificar o preenchimento',
        status: 'warning',
        duration: 9000,
        isClosable: true
      });
      return;
    }

    setDataListFilterFields({
      nome: nameFilter,
      cpf: cpfFilter,
      status: statusFilter,
      data_solicitacao: dataSolicitacaoFilter,
      data_efetivacao: dataEfetivacaoFilter
    });
  };

  useEffect(() => {
    refetchDataList();
    setSearchParams(`page=1`);
    //setItemsCount(1);
  }, [dataListFilterFields]);

  /* const handleFilter = async () => {
    const nameFilter = nameInputRef.current.value;
    const productFilter = productInputRef.current.value;
    const statusFilter = statusSelectRef.current.value;

    console.log({
      nameFilter,
      cpfFilter,
      productFilter,
      statusFilter
    });

    //setLoadingTable(true);

    if (cpfFilter.length > 0 && cpfFilter.length < 11) {
      toast({
        position: 'top',
        description: 'CPF incompleto, favor verificar o preenchimento',
        status: 'warning',
        duration: 9000,
        isClosable: true
      });

      //setLoadingTable(false);

      return;
    }

    await getData();

    if (cpfFilter.length > 0) {
      const newTable = data.table.filter((item: { CPF: string | string[] }) =>
        item.CPF.includes(cpfFilter.replaceAll('.', '').replace('-', ''))
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (nameFilter.length > 0) {
      const newTable = data.table.filter((item: { NOME: string }) =>
        item.NOME.toLowerCase().includes(
          nameFilter.toLowerCase().replaceAll(/\s/g, '')
        )
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (productFilter.length > 0) {
      const newTable = data.table.filter(
        (item: {
          COD_PRODUTO: { toString: () => string };
          DES_PRODUTO: { toString: () => string };
        }) => {
          return (
            item.COD_PRODUTO.toString()
              .toLowerCase()
              .includes(productFilter.toLowerCase().replaceAll(/\s/g, '')) ||
            item.DES_PRODUTO.toString()
              .toLowerCase()
              .includes(productFilter.toLowerCase().replaceAll(/\s/g, ''))
          );
        }
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (statusFilter.length > 0) {
      const newTable = data.table.filter((item: { STATUS: string }) =>
        item.STATUS.toLowerCase().includes(
          statusFilter.toLowerCase().replaceAll(/\s/g, '')
        )
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    setLoadingTable(false);
  }; */

  const handleModals = async () => {
    onClose4();
    onOpen3();
  };

  const handleClearFilters = async () => {
    nameInputRef.current.value = '';
    cpfInputRef.current.inputElement.value = '';
    statusSelectRef.current.value = '';
    setDataSolicitacao(undefined);
    setDataEfetivacao(undefined);

    setDataListFilterFields({
      cpf: '',
      nome: '',
      status: '',
      data_efetivacao: undefined,
      data_solicitacao: undefined
    });
  };

  const exportData = (ext: 'csv' | 'xls') => {
    const data = formatDataEfetivado() as any;
    const fileName = `Dados`;
    const exportType = exportFromJSON.types[ext];

    exportFromJSON({ data, fileName, exportType });
  };

  const formatDataEfetivado = () => {
    return listData?.map(
      (item: {
        CODIGO_EV: any;
        NOME: any;
        CPF: any;
        PROPOSTA: any;
        DATA_SOLICITACAO: any;
        DATA_PAGAMENTO: any;
        VALOR_EMPRESTIMO: any;
        TIPO_SITUACAO: any;
      }) => {
        return {
          'Nome Cliente': item.NOME,
          'CPF Cliente': item.CPF,
          Status: item.TIPO_SITUACAO,
          'Código EV': item.CODIGO_EV,
          Proposta: item.PROPOSTA,
          'Data Solicitação': item.DATA_SOLICITACAO,
          'Data Efetivação:': item.DATA_PAGAMENTO,
          Valor: item.VALOR_EMPRESTIMO
        };
      }
    );
  };

  useEffect(() => {
    if (listData) {
      setTable(listData);
    }
  }, [listData]);

  const handlePageChange = (page: number) => {
    console.log({ page });
    setSearchParams(`page=${page}`);
  };

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  });

  return (
    <Stack p="1.7vw " spacing={23}>
      <Stack spacing={7}>
        <Stack spacing={1}>
          <Link href="/corretor" w="4rem">
            <HStack spacing={0}>
              <ChevronLeftIcon />
              <Text fontSize="1rem" color="#696969" fontWeight="bold">
                Voltar
              </Text>
            </HStack>
          </Link>
          <Flex justifyContent="space-between" alignItems="center">
            <Text color="#00335E" fontWeight="bold" fontSize="1.2rem">
              SOS Prev
            </Text>
            <Menu>
              <MenuButton
                bg="none"
                variant="outline"
                border="1px"
                borderColor="#1B365D"
                color="#1B365D"
                fontSize="0.8rem"
                as={Button}
                rightIcon={<ChevronDownIcon />}
              >
                Exportar Dados
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => exportData('csv')}>
                  Baixar .csv
                </MenuItem>
                <MenuItem onClick={() => exportData('xls')}>
                  Baixar .xls
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Stack>

        <HStack
          bg="#fff"
          wrap="wrap"
          borderRadius="1rem"
          minH="4.3rem"
          spacing={39}
          justify={isWideVersion ? 'flex-start' : 'center'}
          flexDir={{ base: 'column', lg: 'row' }}
          //pointerEvents={!loading ? 'all' : 'none'}
          //opacity={!loading ? '1' : '0.4'}
        >
          <HStack
            flexDir={{ base: 'column', md: 'column', lg: 'row' }}
            m=".6rem !important"
          >
            <Text fontSize=".8rem" fontWeight="bold" color="#1B365D">
              Filtrar:
            </Text>
            <Input
              ref={nameInputRef}
              color="#1B365D"
              fontSize=".7rem"
              w="8rem"
              h="2.1rem"
              placeholder="Nome"
              // value={nameFilter}
              // onChange={(e) => {
              //   setNameFilter(e.target.value);
              // }}
            />

            <Input
              as={MaskedInput}
              ref={cpfInputRef}
              mask={cpf}
              guide={false}
              color="#1B365D"
              fontSize=".7rem"
              w="9.3rem"
              h="2.1rem"
              placeholder="CPF"
              /* value={cpfFilter}
              onChange={(e) => {
                setCpfFilter(e.target.value);
              }} */
            />
            <Input
              as={DatePicker}
              color="#1B365D"
              fontSize=".7rem"
              h="2.1rem"
              type="text"
              placeholderText="Data da solicitação"
              dateFormat="dd/MM/yyyy"
              locale={ptBR}
              selected={dataSolicitacao}
              onChange={(date: any) => {
                console.log(date);
                setDataSolicitacao(date);
              }}
            />
            <Input
              as={DatePicker}
              color="#1B365D"
              fontSize=".7rem"
              dateFormat="dd/MM/yyyy"
              locale={ptBR}
              h="2.1rem"
              placeholderText="Data da efetivação"
              type="text"
              selected={dataEfetivacao}
              onChange={(date: any) => {
                console.log(date);
                setDataEfetivacao(date);
              }}
            />
            <Select
              ref={statusSelectRef}
              color="#1B365D"
              fontSize=".7rem"
              w="8rem"
              h="2.1rem"
              // value={statusFilter}
              // onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">Todos</option>
              <option value="IN">INFORMADO</option>
              <option value="RE">RECUSADO</option>
              <option value="AT">ATIVO</option>
              <option value="CA">CANCELADO</option>
              <option value="QT">QUITADO</option>
            </Select>
          </HStack>

          <Button
            bg="#FA6B25"
            color="#fff"
            fontSize=".7rem"
            w="5.5rem"
            h="2.1rem"
            isLoading={false}
            onClick={handleFilter}
            m="0 !important"
            _hover={{
              opacity: '.9'
            }}
          >
            Filtrar
          </Button>
          <Button
            bg="#ACACAC"
            color="#fff"
            fontSize=".7rem"
            w="5.5rem"
            h="2.1rem"
            onClick={handleClearFilters}
            m=".3rem !important"
            _hover={{
              opacity: '.9'
            }}
          >
            Limpar Filtros
          </Button>
        </HStack>
      </Stack>

      <Stack
        bg="#fff"
        color="#00335E"
        borderRadius="1rem"
        p="1.4rem 1.1rem .8rem"
      >
        <Flex wrap="wrap" gap="5" justify="center">
          <ValueCard
            value={summarizedData.quantidadeSolicitacoes?.toString()}
            description="Quantidade de solicitações"
            isLoading={isLoadingSum}
          />
          <ValueCard
            //prefix={income === '-' ? '' : 'R$'}
            value={new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }).format(summarizedData.valorSaldo)}
            fontSize="1.5rem"
            description="Valor"
            isLoading={isLoadingSum}
          />
        </Flex>
        {table.length ? (
          <InteractiveTable
            sort="NOME"
            columns={columns}
            data={table}
            itemsCount={itemsCount}
            withPagination={withPagination}
            onPageChange={handlePageChange}
            activePageIndex={Number(page) || 1}
            isLoadingData={isLoadingList || isFetchingList}
            isLoadingCountPagination={isLoadingCount}
          />
        ) : (
          <Text align="center" my="2">
            Nenhum dado encontrado
          </Text>
        )}
      </Stack>
      <Flex
        w="100%"
        justify="flex-end"
        fontSize=".9rem"
        align="center"
        mt="2.1rem"
      >
        <Flex
          w={{ base: '100%', lg: '60%' }}
          justify={{ base: 'center', lg: 'space-between' }}
          flexDir={{ base: 'column', lg: 'row' }}
        >
          {!isLoadingList && withPagination === false && (
            <>
              <Flex
                align="center"
                cursor="pointer"
                justify="center"
                onClick={() => {
                  setItemsCount(
                    itemsToShow + itemsCount > table.length
                      ? table.length
                      : itemsToShow + itemsCount
                  );
                }}
              >
                <HiPlusCircle size={26} color="#00335E" />
                <Text>
                  Mais itens (exibindo {itemsCount}/{table.length})
                </Text>
              </Flex>
              <Box>
                <Select
                  border="1px solid #00335E !important"
                  borderRadius="1rem !important"
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                    setItemsToShow(parseInt(e.target.value))
                  }
                >
                  <option value={5}>exibir mais 5 por vez</option>
                  <option value={10}>exibir mais 10 por vez</option>
                  <option value={20}>exibir mais 20 por vez</option>
                  <option value={40}>exibir mais 40 por vez</option>
                </Select>
              </Box>
            </>
          )}
        </Flex>
      </Flex>

      <Modal isOpen={isOpen2} onClose={onClose2}>
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>Atenção!</ModalHeader>

          <ModalBody>
            <Text>Ops, sua sessão expirou.</Text>
            <Text>
              Por favor, faça novamente o login no Portal do Corretor.
            </Text>
          </ModalBody>

          <ModalFooter justifyContent="center">
            <Link href={process.env.REACT_APP_PORTAL_URL}>
              <Button bg="#FA6B25" color="#fff" colorScheme="orange">
                Voltar
              </Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isOpen3}
        onClose={onClose3}
        size="5xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>Fundos</ModalHeader>
          <ModalCloseButton />

          <Divider />
          {loadingFundos ? (
            <Flex w="100%" justify="center" align="center" h="10rem">
              <Spinner />
            </Flex>
          ) : (
            <ModalBody></ModalBody>
          )}
          <Divider mt="1rem" />
          <ModalFooter justifyContent="center"></ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isOpen4}
        onClose={onClose4}
        size="5xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent textAlign="center">
          <Box display="flex" p="0rem 0.8rem" alignItems="center">
            <Text
              fontSize="0.9rem"
              fontWeight="bold"
              color="grey"
              cursor="pointer"
              onClick={handleModals}
            >
              {'<'} Voltar
            </Text>
            <ModalHeader>Fundos</ModalHeader>
          </Box>
          <ModalCloseButton />
          <Divider />
          {loadingFundosClientes ? (
            <Flex w="100%" justify="center" align="center" h="10rem">
              <Spinner />
            </Flex>
          ) : (
            <>
              <Box
                display="flex"
                justifyContent="left"
                background="#1C375C"
                color="#fff"
                fontSize="1.5rem"
                width="100%"
              >
                <Text p="0.8rem">
                  {tableFundosClientesHeader.NOME_FUNDO}:{' '}
                  {+tableFundosClientesHeader.SALDO_FUNDO > 0
                    ? 'R$' +
                      parseFloat(
                        tableFundosClientesHeader.SALDO_FUNDO
                      ).toLocaleString('PT-BR')
                    : '-'}
                </Text>
              </Box>
              <ModalBody>
                <TableContainer>
                  <Table size="sm" variant="striped" maxHeight="60vh">
                    <Thead h="3.25rem">
                      <Tr>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          Participante
                        </Th>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          CPF
                        </Th>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          Nº da proposta
                        </Th>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          Produto
                        </Th>
                      </Tr>
                    </Thead>

                    <Tbody>
                      {tableFundosClientes.map((row, i) => (
                        <Tr key={i}>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.DESCRICAO}
                          </Td>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.CPF}
                          </Td>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.PROPOSTA}
                          </Td>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.DES_PRODUTO}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </ModalBody>
            </>
          )}
          <Divider mt="1rem" />
          <ModalFooter justifyContent="center"></ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpenAlert}
        onClose={onCloseAlert}
      >
        <ModalOverlay />
        <ModalContent textAlign="center" h="10rem">
          <ModalHeader>Atenção!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Essa funcionalidade está passando por manutenção.</Text>
            <Text>
              Por favor, continue utilizando o restante dos serviços até que
              seja normalizado. Obrigado!
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Stack>
  );
};
